module.exports = __webpack_public_path__ + "static/13-PROPTECH-3-POWERED-BY-BLOCKCHAIN-AND-AI-79b2180deb120ea6b165978b32c8af39.png";